import { createStore } from 'services/Flux'
import { actionsType } from 'config/constants'


const setLoading = (state, action) => {
    let newState = { ...state };
    newState.loading = action.payload;
    return newState;
}

const setFavorites = (state, action) => {
    if (!action.payload) {
        return state;
    }

    let newState = { ...state };
    newState.favorites = action.payload;
    return newState;
}

const Store = createStore((state, action) => {
    switch(action.type) {
        case actionsType.UPDATE_FAVORITES:
            return setFavorites(state, action)
        case actionsType.SET_LOADING_FAVORITES:
            return setLoading(state, action)
        default: 
            return state
    }
}, {
    loading: false,
    favorites: null 
}, 'favorites' )

export default Store